import { Tables } from '../tables'
import { getTable } from '../utils'

export type StoredPlayerRef = { shortName: string; id: number | null }

export type PlayersSecondaryPositionRecord = {
  eventId: number
  participantId: number
  players: StoredPlayerRef[]
  /** Last saved Pitchers-section order. SportsAPI leaves `lineup_order` null for pitchers. */
  pitcherOrder?: StoredPlayerRef[]
}

export async function setPlayers(
  eventId: number,
  participantId: number,
  players: StoredPlayerRef[],
  pitcherOrder: StoredPlayerRef[] = [],
): Promise<void> {
  const table = getTable(Tables.PLAYER_SECONDARY_POSITION)

  await table.put({
    eventId,
    participantId,
    players,
    pitcherOrder,
  })
}

export async function get(
  eventId: number,
  participantId: number,
): Promise<PlayersSecondaryPositionRecord | undefined> {
  const table = getTable(Tables.PLAYER_SECONDARY_POSITION)

  return table.get({ eventId, participantId })
}

export async function getAll(
  eventId: number,
): Promise<PlayersSecondaryPositionRecord[]> {
  const table = getTable(Tables.PLAYER_SECONDARY_POSITION)

  return table.where('eventId').equals(eventId).toArray()
}

export async function remove(eventId: number): Promise<number> {
  const table = getTable(Tables.PLAYER_SECONDARY_POSITION)

  return table.where('eventId').equals(eventId).delete()
}
